import { HospitalType } from 'src/app/shared/lib/facility-rate/models/hospital-types.enum';
import { MarginCalculatorDetailModel } from './margin-calculator-detail.model';
import { MarginCalculatorExpenseAllModel } from './margin-calculator-expense-all.model';
import { MarginCalculatorInsuranceModel } from './margin-calculator-insurance.model';
import { MarginType } from '../enum/margin-type.enum';

export interface MarginCalculatorModel {
    id: number;
    userId: number;
    fileName: string;
    marginPct: number;
    marginDollars: number;
    marginBillRate: number;
    marginPayRate: number;
    targetMargin?: number;
    dateCreated: Date;
    createdBy: number;
    dateModified: Date;
    modifiedBy: number;
    isDeleted: boolean;
    isPipelined: boolean;
    dateDeleted: Date;
    deletedBy: number;
    version: number;
    contractId: number;
    contractStageCode: string;
    contractStageDescription: string;
    datePipelined?: Date;
    isLinkedContractRequestInDraftingStatus: boolean;
    openContractRequestId?: number;
    isOfferMargin: boolean;
    offerId?: number;
    jobId?: number;
    detail: MarginCalculatorDetailModel;
    expenseAll: MarginCalculatorExpenseAllModel;
    insurance: MarginCalculatorInsuranceModel;
    sampleMarginJobs: SampleMarginJob[];
    duplicatedFromMarginId?: number;
    importedFromMarginId?: number;
    job?: {
        facilityName: string;
        city: string;
        stateCode: string;
        specialtyName: string;
    };
    averageHourlyTaxable?: number;
    weeklyPay?: number;
    altWeeklyPay?: number;
    marginTypeId: MarginType;
    globalFacilityKey?: string;
}

export interface SampleMarginJob {
    jobId: number;
    hospitalType: HospitalType;
}

/**
 * @deprecated This class should not be used. Use the interface MarginCalculatorModel instead.
 */
export class MarginCalculator implements MarginCalculatorModel {
    id: number;
    userId: number;
    fileName: string;
    marginPct: number;
    marginDollars: number;
    marginBillRate: number;
    marginPayRate: number;
    dateCreated: Date;
    createdBy: number;
    dateModified: Date;
    modifiedBy: number;
    isDeleted: boolean;
    isPipelined: boolean;
    dateDeleted: Date;
    deletedBy: number;
    version: number;
    contractId: number;
    contractStageCode: string;
    contractStageDescription: string;
    datePipelined: Date;
    detail: MarginCalculatorDetailModel;
    expenseAll: MarginCalculatorExpenseAllModel;
    insurance: MarginCalculatorInsuranceModel;
    responseStatus: number;
    errors: string[];
    isLinkedContractRequestInDraftingStatus: boolean;
    sampleMarginJobs: SampleMarginJob[];
    isOfferMargin: boolean;
    offerId?: number;
    jobId?: number;
    duplicatedFromMarginId?: number;
    marginTypeId: MarginType;
}
